import {ColDef} from "ag-grid-community";
import AbsAGGridEditViewColumn from "@/utils/UIConstants/AGGridEditViewColumns/AbsAGGridEditViewColumn.ts";
import AGGridIconCellRenderer from "@/components/inputs/AGGridIconCellRenderer.vue";
import AGGridIconCellEditor from "@/components/inputs/AGGridIconCellEditor.vue";
import EditableGridHandler from "@/utils/presenters/EditableGridHandler.ts";
import EditScreenGridColumn = namaTypes.EditScreenGridColumn;

export default class AGGridEditViewIconColumn extends AbsAGGridEditViewColumn {
  constructor(column: EditScreenGridColumn, handler: EditableGridHandler) {
    super(column, handler);
  }

  override createColDef(): ColDef[] {
    let colDef = AbsAGGridEditViewColumn.defaultColDef(this);
    colDef.cellRenderer = AGGridIconCellRenderer;
    colDef.cellEditor = AGGridIconCellEditor;
    return [colDef];
  }
}
